export default __webpack_public_path__ + "static/media/beachWeekend.41f7ff27.png";